import { selectShare } from './share.selector';
import { createSelector } from '@ngrx/store';
import { selectCurrentNote } from './current-note.selector';

export const selectChildren = createSelector(
  selectShare,
  selectCurrentNote,
  (share: any, currentNote) => {
    const {result:{entities}} = share;
    if (!currentNote || !currentNote.children ) {
      return [];
    }
    return Object.keys(currentNote.children)
      .map((key) => currentNote.children[key])
      .map((noteGlobalId) => {
        const note = entities.notes[noteGlobalId];
        if (note) {
          const text = entities.texts ? entities.texts[noteGlobalId] : "";
          return Object.assign({}, note, {text});
        } else {
          return undefined;
        }
      })
      .sort((a, b) => {
        return (a.dateUpdated > b.dateUpdated) ? 1 :
          ((a.dateUpdated < b.dateUpdated) ? -1 : 0);
      });
  }
);

export const selectChildrenNotesCount = createSelector(
  selectChildren,
  (children) => {
    const notes = children.filter((child) => child.type == 'note');
    return notes ? notes.length : 0;
  }
)
